import constants from 'constants/index'

const isTemplate = (company) =>
  company?.kind === constants.companies.KINDS.TEMPLATE

export default isTemplate
